import { UnitError } from './UnitError';

export class UnknownUnitError extends UnitError {
  constructor(badUnit: string) {
    super(`Unknown unit "${badUnit}"`);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, UnknownUnitError);
    }
    Object.setPrototypeOf(this, UnknownUnitError.prototype);
  }
}
